declare var ApexCharts: any;

$(function () {
    const stats = (window as any).dashboardStats;
    if (!stats || !document.getElementById('chart_consumo_tendencia')) return;

    // Process daily stats
    const dailyData = stats.consumo_por_dia;
    const sortedDays = Object.keys(dailyData).sort();
    const last7Days = sortedDays.slice(-7);
    
    const categories = last7Days.map(day => {
        const d = new Date(day + 'T00:00:00');
        return d.toLocaleDateString('es-PE', { weekday: 'short', day: 'numeric' });
    });
    
    const seriesData = last7Days.map(day => dailyData[day]);

    var options = {
        series: [{
            name: 'Consumo (kWh)',
            data: seriesData
        }],
        chart: {
            fontFamily: 'inherit',
            type: 'area',
            height: 350,
            toolbar: {
                show: false
            }
        },
        plotOptions: {},
        legend: {
            show: false
        },
        dataLabels: {
            enabled: false
        },
        fill: {
            type: 'gradient',
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.4,
                opacityTo: 0,
                stops: [0, 80, 100]
            }
        },
        stroke: {
            curve: 'smooth',
            show: true,
            width: 3,
            colors: ['#009EF7']
        },
        xaxis: {
            categories: categories,
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false
            },
            labels: {
                style: {
                    colors: '#A1A5B7',
                    fontSize: '12px'
                }
            },
            crosshairs: {
                position: 'front',
                stroke: {
                    color: '#009EF7',
                    width: 1,
                    dashArray: 3
                }
            },
            tooltip: {
                enabled: true,
                formatter: undefined,
                offsetY: 0,
                style: {
                    fontSize: '12px'
                }
            }
        },
        yaxis: {
            labels: {
                style: {
                    colors: '#A1A5B7',
                    fontSize: '12px'
                }
            }
        },
        states: {
            normal: {
                filter: {
                    type: 'none',
                    value: 0
                }
            },
            hover: {
                filter: {
                    type: 'none',
                    value: 0
                }
            },
            active: {
                allowMultipleDataPointsSelection: false,
                filter: {
                    type: 'none',
                    value: 0
                }
            }
        },
        tooltip: {
            style: {
                fontSize: '12px'
            },
            y: {
                formatter: function (val: number) {
                    return val + " kWh"
                }
            }
        },
        colors: ['#009EF7'],
        grid: {
            borderColor: '#E4E6EF',
            strokeDashArray: 4,
            yaxis: {
                lines: {
                    show: true
                }
            }
        },
        markers: {
            strokeColors: ['#009EF7'],
            strokeWidth: 3
        }
    };

    var chart = new ApexCharts(document.querySelector("#chart_consumo_tendencia"), options);
    chart.render();
});
